import { asc, count } from "drizzle-orm";
import { organization, type PowerSyncDrizzleDB } from "@space/powersync";

/**
 * Shared Drizzle query builder for fetching organization counts.
 */
export function getOrganizationCountQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({
      count: count(organization.id).mapWith(Number),
    })
    .from(organization);
}

/**
 * Organizations the user belongs to (local-first). The `organizations`
 * stream only syncs the orgs they're a member of, so reading the local
 * table already returns "my orgs". Used by the leaderboard's league
 * selector (each org is a league).
 */
export function getMyOrganizationsQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({ id: organization.id, name: organization.name })
    .from(organization)
    .orderBy(asc(organization.name));
}
